import { useLazyQuery, useSubscription } from "@apollo/client";
import { COUNT_NOTIFICATION_BADGE } from "domains/Notification/graphql/queries";
import { NOTIFICATION_SUBSCRIPTION } from "domains/Notification/graphql/subscription";
import { EPlatform } from "generated/graphql";
import { useCurrentUser } from "hooks/useCurrentUser";
import React from "react";
import { STATUS_CODE } from "utils/status";
import { useAlertDispatch } from "./AlertContext";

interface INotificationPopup {
  badge: number;
  setBadge: React.Dispatch<React.SetStateAction<number>>;
}

const notifSound = new Audio("/assets/notification-sound.wav");
notifSound.volume = 0.1;
const NotificationPopupContext = React.createContext<INotificationPopup>(null);

export const NotificationConsumer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [badge, setBadge] = React.useState(0);
  const setAlert = useAlertDispatch();
  const { user } = useCurrentUser();
  const [getBadgeNotification, { data: resultBadge }] = useLazyQuery(COUNT_NOTIFICATION_BADGE);
  useSubscription(NOTIFICATION_SUBSCRIPTION, {
    variables: { viewerClient: user?.company_user_clientId },
    onSubscriptionData: async (data) => {
      const notification = data.subscriptionData.data?.notification;
      if (notification) {
        await notifSound.play();
        setBadge(badge + 1);
        setAlert({ severity: "info", message: notification?.content });
      }
    },
  });
  React.useEffect(() => {
    getBadgeNotification({
      variables: {
        viewerId: user?._id,
        viewerPlatform: user?.company_user_clientId,
        platform: EPlatform.Client,
      },
    });
  }, []);
  React.useEffect(() => {
    if (resultBadge?.countNotificationsByPlatform?.code === STATUS_CODE.OK) {
      setBadge(resultBadge?.countNotificationsByPlatform?.data);
    }
  }, [resultBadge]);
  return <NotificationPopupContext.Provider value={{ badge, setBadge }}>{children}</NotificationPopupContext.Provider>;
};

export const useNotification = () => React.useContext(NotificationPopupContext);
